export let productCenterPDRHeaViewEN = {
  module: {
    h1: "Recursive Hierarchic Scenario Generator",
    h2: "Infinite Random On one click",
    h3: "Fully Automated Infinite Scenario Randomization and Generation",
    h4: "Upgraded functions! Meet the requirements of higher-level automated driving testing scenarios",
    h5: "Organic Fusion of AI with Physics-Based ",
    h6: "Environmental Perception Sensor Models",
    h7: "Random Scenario Generation",
    h8: "Recursive Iteration Based on Hierarchical Scenario Element Parameters",
    h9: "Reflection Characteristic Rproduction",
    h10: "Reflection characteristics of visible light, 77/79 GHz millimeter waves,",
    h11: " and 905/1550 nm laser waves",
    h12: "Nirvana",
    h13: "Ukiyoshi",
  },
  function: {
    h1: "What Can PDRHea Do？",
    h2: "Generate Infinite Random Scenario",
    h3: "Break the limitation of fixed scenario sets that cannot cover unknown scenarios.",
    h4: "Close-loop Simulation of Multiple Modules",
    h5: "High quality close-loop simulation of multiple modules, including raw sensor data, perception, PNC etc.",
  },
};
export let productCenterPDRHeaViewCN = {
  module: {
    h1: "递归式分层场景生成器",
    h2: "无限 随机 一步到位",
    h3: "全自动化随机生成无限场景",
    h4: "功能再升级！满足更高阶自动驾驶测试场景需求",
    h5: "AI 技术与物理级环境感知传感器模",
    h6: "型的有机结合",
    h7: "随机方式生成场景",
    h8: "基于分层场景元素参数递归式迭代",
    h9: "反射特性重现",
    h10: "针对可见光、77/79 Ghz毫米波以及 905/1550 nm激光波的",
    h11: "反射特性",
    h12: "涅 槃",
    h13: "浮 世",
  },
  function: {
    h1: "PDRHea 可以做什么？",
    h2: "随机生成无限场景",
    h3: "解决固定场景集数量有限且无法覆盖未知场景的问题",
    h4: "多个模块的闭环仿真",
    h5: "从原始传感器数据，到感知，到PNC等多个模块的高质量闭环仿真",
  },
};
